import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useSEO } from "../hooks/useSEO";
import { Link } from "react-router-dom";
import "../styles/resources.css";

function Resources() {
  useSEO({
    title: "Resources | Guides, Tools & Learning Materials | Empower Web",
    description:
      "Access valuable resources including guides, tutorials, whitepapers, and tools for digital marketing and web development.",
    canonical: "https://empowerweb.in/resources",
    ogTitle: "Resources | Learning Materials & Tools",
    ogDescription:
      "Access our collection of guides, tutorials, and tools for digital success.",
    keywords:
      "resources, guides, tutorials, whitepapers, tools, learning materials, educational content",
  });
  return (
    <div>
      <Header />
      <Navbar />
      <section className="portfolio-banner">
        <div className="portfolio-banner-content">
          <h1 className="portfolio-title">Resources</h1>
          <br />
          <p className="portfolio-subtitle">
            Explore our collection of useful sources, professional courses, and
            practical tools designed to help your digital increase and
            commercial enterprise achievement. Whether you are seeking to
            enhance your on-line presence or beautify your technical talents,
            our assets provide precious insights and actionable strategies.
          </p>
        </div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span>Resources</span>
      </div>

      <section className="resources-section">
        <div className="resources-container">
          <h2 className="resources-heading">
            Empower Your Growth with Expert Resources
          </h2>

          <p className="resources-text">
            Explore expert guides, tutorials, and equipment designed to
            reinforce your digital growth. Learn realistic techniques, enhance
            competencies, and attain better results with our valuable and
            easy-to-use sources.
          </p>

          <div className="resources-grid">
            <div className="resource-card">
              <h3>Guides & Whitepapers</h3>
              <p>
                Comprehensive guides and whitepapers on digital marketing and
                web development.
              </p>
            </div>

            <div className="resource-card">
              <h3>Tutorials & Training</h3>
              <p>Learn from our expert tutorials and training materials.</p>
            </div>

            <div className="resource-card">
              <h3>Tools & Templates</h3>
              <p>Useful tools and templates to accelerate your projects.</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
     
    </div>
  );
}

export default Resources;
